import base from 'stores/search-base/mutations';
import * as types from './mutation-types';

export default {
  ...base,
  [types.SET_TRACK_NEXT_SEARCH](state, trackNextSearch) {
    state.trackNextSearch = trackNextSearch;
  }
};
